import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './CustomLoginForm.css'; // ajoute ton style ici si nécessaire
import logo from './assets/logofinal-thmb.png';

const CustomLoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://weavevo.com/auth/realms/master/protocol/openid-connect/token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          client_id: 'weavevo-frontend',
          client_secret: 'CaoSHmZcQVz7AVCaY9JwwbNXSUE4ULv2',
	        grant_type: 'password',
          username,
          password,
	  scope: 'openid'	
           }),
      });

      if (!response.ok) throw new Error('Échec de la connexion');

      const data = await response.json();
      const token = data.access_token;
      const payload = JSON.parse(atob(token.split('.')[1]));

      login(token, { name: payload.name, email: payload.email });
      navigate('/dashboard');
    } catch (error) {
      alert('Erreur de connexion');
      console.error('Erreur login :', error);
    }
  };

  return (
    <div className="login-pf body">
      <div className="login-pf-page">
        <div id="kc-header" className="login-pf-header text-center mb-3">
          <img src={logo} alt="logo" style={{ height: 60 }} />
        </div>

        <div id="kc-content">
          <div id="kc-content-wrapper" className="card p-4 shadow-sm">
            <form onSubmit={handleLogin}>
              <div className="form-group mb-3">
                <label htmlFor="username" className="form-label">Nom d’utilisateur</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  className="form-control"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  autoFocus
                />
              </div>

              <div className="form-group mb-4">
                <label htmlFor="password" className="form-label">Mot de passe</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="d-grid">
                <button type="submit" className="btn btn-primary">
                  Se connecter
                </button>
              </div>
            </form>

            <hr className="my-4" />
            <div className="text-center">
              <button
                className="btn btn-outline-dark w-100"
                onClick={() =>
                (window.location.href =
                  'https://weavevo.com/auth/realms/master/protocol/openid-connect/auth?client_id=weavevo-frontend&redirect_uri=https://weavevo.com/auth/callback&response_type=code&scope=openid&kc_idp_hint=google')

                }
              >
                <i className="bi bi-google me-2"></i> Continuer avec Google
              </button>
            </div>
            <div className="text-center mt-3">
              <span className="text-muted">Pas encore de compte ? </span><br></br>
              <a
                href="https://weavevo.com/auth/realms/master/protocol/openid-connect/auth?client_id=weavevo-frontend&redirect_uri=https://weavevo.com/auth/callback&response_type=code&scope=openid&kc_idp_hint=google"
                className="text-decoration-none fw-semibold"
              >
                Créer un compte
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomLoginForm;
